// extracted by mini-css-extract-plugin
export var clockContainer = "Clock-module--clockContainer--zue1Y";
export var clockHours = "Clock-module--clockHours--mTfBc";
export var clockMinutes = "Clock-module--clockMinutes--ZaLBb";
export var clockSeconds = "Clock-module--clockSeconds--gpnIb";
export var page404Title = "Clock-module--page404-title--fzrcN";